// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Реєстр лобістів» (Lobbyist Register, ключ `lbr`, група `advocacy`). */
export const lobbyistRegisterManifest: IModuleManifest = {
  key: 'lbr',
  group: 'advocacy',
  slug: 'lobbyist-register',
  prefix: 'LBR',
  name: { en: 'Lobbyist Register', uk: 'Реєстр лобістів' },
  entities: [
    { key: 'lbr', slug: 'lbr', name: { en: 'Lobbyist Register', uk: 'Реєстр лобістів' }, main: true },
    { key: 'organisation_representative', slug: 'organisation-representative', name: { en: 'Organisation Representatives', uk: 'Представники' }, main: false },
    { key: 'organisation_client', slug: 'organisation-client', name: { en: 'Organisation Clients', uk: 'Клієнти' }, main: false },
    { key: 'organisation_accreditation', slug: 'organisation-accreditation', name: { en: 'Organisation Accreditations', uk: 'Акредитації' }, main: false },
  ],
  loadState: () => import('./state/lobbyistRegisterSlice').then((m) => m.lobbyistRegisterSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
